import { AxiosInstance } from "axios"
import {
    CreateCarResource,
    CreateMobileAVResource,
    CreateRoomResource,
    OrganizationResourceUnion,
    ResourceType,
} from "./resourcesTypes"
import { ServiceResponse } from "../../../../../core/api/apiTypes"

export enum ServiceCenterResourcesQuery {
    SERVICE_CENTER_RESOURCES = "SERVICE_CENTER_RESOURCES",
}

export type FetchResourcesParams = Readonly<{
    serviceCenterId: number
    type: ResourceType
}>

export type FetchResourcesResponse = Readonly<{
    resources: Array<OrganizationResourceUnion>
}>

export async function fetchResources(
    { serviceCenterId, type }: FetchResourcesParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchResourcesResponse> {
    const url = `/serviceCenters/${serviceCenterId}/resources`

    const response = await axios.get(url, {
        params: {
            type,
        },
        signal,
    })

    return response.data
}

type ServiceCenterCreateResourcesParams =
    | Readonly<CreateRoomResource>
    | Readonly<CreateCarResource>
    | Readonly<CreateMobileAVResource>

export async function createResource(
    data: ServiceCenterCreateResourcesParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const response = await axios.post("/resources", data, {
        signal,
    })

    return response.data
}

export async function editResource(
    { roomId, ...data }: ServiceCenterCreateResourcesParams & { roomId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const response = await axios.post(`/resources/${roomId}`, data, {
        signal,
    })

    return response.data
}

export type FetchRoomResponse = CreateRoomResource

export async function getResource(
    { roomId }: { roomId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchRoomResponse> {
    const response = await axios.get(`/resources/${roomId}`, {
        signal,
    })

    return response.data
}

export type FetchCarResponse = CreateCarResource

export async function getCarResource(
    { carId }: { carId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchCarResponse> {
    const response = await axios.get(`/resources/${carId}`, {
        signal,
    })

    return response.data
}

export type FetchMobileAVResponse = CreateMobileAVResource

export async function getMobileAVResource(
    { mobileAVId }: { mobileAVId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchMobileAVResponse> {
    const response = await axios.get(`/resources/${mobileAVId}`, {
        signal,
    })

    return response.data
}
